import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgArrowIn = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M13.44 5.723c.323 0 .59.246.622.561l.002.064v7.07l-.002.065a.626.626 0 0 1-.559.558l-.063.003H6.369a.625.625 0 1 1 0-1.25h5.561l-5.499-5.5a.625.625 0 0 1 .884-.883l5.5 5.5V6.348l.002-.064a.626.626 0 0 1 .623-.561"
      />
    </svg>
  );
};
export default SvgArrowIn;
